import { __ } from '@wordpress/i18n';
import { useBlockProps } from '@wordpress/block-editor';
import { useEffect } from '@wordpress/element';
import Style from './Style';

import blockJson from './block.json';
import Icon from './index.jsx';

export default function Edit( props ) {
	const { attributes, setAttributes, clientId, isSelected } = props;

	const { blockId } = attributes;

	useEffect( () => {
		setAttributes( { blockId: clientId } );
	}, [ clientId ] );

	const blockProps = useBlockProps( {
		className: `alpha-icon-block-${ blockId }`,
	} );

	return (
		<div { ...blockProps }>
			<Style
				{ ...props }
				blockId={ blockId }
				setAttributes={ setAttributes }
			/>
			{ isSelected && (
				<window.InspectorGenerator props={ props } blockJson={ blockJson } />
			) }
			<Icon name={ attributes.icon.iconName } />
		</div>
	);
}
